'use strict';

var React = require('react');
var reactUtils = require('@sravni/react-utils');
var Space = require('../../Space/src/Space.js');
var Tabs_module = require('../styles/Tabs.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

/**
 * @description Use Tabs to organize your content in logical groupings
 *
 * @component
 * @example
 * ```jsx
 * <Tabs activeKey="tab-key">
 *   <Tabs.TabPane key="tab-key" title="Tab">tab content</Tabs.TabPane>
 * </Tabs>
 * ```
 */
const Tabs = React__namespace.forwardRef((props, ref) => {
    const { defaultIndex = 0, index, color = 'gray', view = 'badge', className, children, onChange, ...restProps } = props;
    const innerChildren = React__namespace.useMemo(() => React__namespace.Children.toArray(children).filter(Boolean), [children]);
    const [innerValue, setInnerValue] = React__namespace.useState(index ?? defaultIndex);
    const cx = reactUtils.useStyles(Tabs_module.default);
    const handleChangeActiveTab = React__namespace.useCallback((event) => {
        const value = Number(event.currentTarget.dataset.index);
        setInnerValue(value);
        onChange?.(value);
    }, [onChange]);
    const navigation = React__namespace.useMemo(() => React__namespace.Children.map(innerChildren, (child, index) => {
        const classNames = cx('tab', {
            active: index === innerValue,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            'view-text': view === 'text',
            [`color-${color}`]: true,
        });
        return (React__namespace.createElement(Space.Space, { "data-qa": "Tab", size: 4, align: "center", inline: true, className: classNames, "data-index": index, onClick: handleChangeActiveTab }, child.props.title));
    }), [innerChildren, cx, innerValue, view, color, handleChangeActiveTab]);
    const panes = React__namespace.useMemo(() => React__namespace.Children.map(innerChildren, (child, index) => {
        const classNames = cx(child.props.className, 'pane', {
            active: index === innerValue,
        });
        return React__namespace.cloneElement(child, { ...child.props, className: classNames });
    }), [innerChildren, cx, innerValue]);
    React__namespace.useEffect(() => {
        if (!reactUtils.isDefined(index)) {
            return;
        }
        setInnerValue(index);
    }, [index]);
    return (React__namespace.createElement("div", { ref: ref, "data-qa": "Tabs", className: className, ...restProps },
        React__namespace.createElement(Space.Space, { size: view === 'text' ? 16 : 12, align: "center", className: cx('tabs') }, navigation),
        React__namespace.createElement("div", { className: cx('panes') }, panes)));
});
Tabs.defaultProps = {
    color: 'gray',
    defaultIndex: 0,
    view: 'badge',
};
Tabs.displayName = 'Tabs';

exports.Tabs = Tabs;
//# sourceMappingURL=Tabs.js.map
